export const FBA_SHIPMENT_ID_REGEX_PATTERN = /(^FBA[A-Z0-9]{9}$|^STAR-[A-Z0-9]{13}$)/;
export const FBA_REFERENCE_ID_REGEX_PATTERN = /^[A-Z0-9]{8}$/;
